import React, { Component } from 'react';

class EditExtension extends Component {
    state = {  }
    render() { 
        return (
            <div>Editar Extensión</div>
        );
    }
}
 
export default EditExtension;


// WEBPACK FOOTER //
// ./src/views/WebMaster/EditExtension.jsx